import React, { useEffect, useRef, useState } from "react";
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { ToastContainer, toast } from "react-toastify";
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import * as THREE from 'three';
import "./Landing.scss";
import axios from "axios";
import APP_BASE_URL from "../../components/Api/globalApi";
import image1 from "../../components/picture/vegetablegarden.png";
import image2 from "../../components/picture/virtualmall.png";
import image3 from "../../components/picture/homecare.png";
import image4 from "../../components/picture/garden.png";
import image5 from "../../components/picture/img5.jpg";
import image6 from "../../components/picture/springwayads.png";
import InstructionCarousel from "./InstructionList";

const realStoredValue = (value) => {
    if (!value || value === "null" || value === "undefined") return "";
    return value;
};

const signedInDashboardPath = () => {
    if (realStoredValue(localStorage.getItem("user_id"))) return "/home";
    if (
        realStoredValue(localStorage.getItem("virtualmall_token")) &&
        realStoredValue(localStorage.getItem("virtual_user_id"))
    ) {
        return "/user-points";
    }
    return "";
};

const LandingPage = () => {
    const [expanded, setExpanded] = useState(false);
    const [AdImages, setAdImages] = useState([]);
    const [EventAdImages, setEventAdImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [scrollProgress, setScrollProgress] = useState(0);
    const navigate = useNavigate();
    const dashboardPath = signedInDashboardPath();

    useEffect(() => {
        if (!dashboardPath) return;
        navigate(dashboardPath, { replace: true });
    }, [dashboardPath, navigate]);

    useEffect(() => {
        const Adlist = async () => {
            try {
                const response = await axios.post(
                    `${APP_BASE_URL}/ads/list`,
                    {}
                );

                if (response?.data?.result) {
                    console.log(response?.data, 'result')
                    setAdImages(response.data.data || []);
                    setEventAdImages(response.data.event_data || []);
                } else {
                    toast.error("Failed to load ads");
                }
            } catch (error) {
                console.error(error);
                toast.error("Failed to load ads");
            } finally {
                setLoading(false);
            }
        };
        Adlist();
    }, []);

    // if (loading) {
    //     return <div>Loading...</div>; // You can show a loading spinner or text
    // }

    const handleScroll = () => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
        const scrollTotal = scrollHeight - clientHeight;
        const progress = (scrollTop / scrollTotal) * 100;
        setScrollProgress(progress);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const products = [
        {
            id: 1,
            image: image3,
            title: "Springway Home care",
            desc: `Cleaning and maintaining a hygienic home is an essential part of a
                healthy lifestyle. Springway offers a range of home care products
                that ensure a safe and sanitized living environment. These products
                are designed to effectively clean surfaces and eliminate germs, making homes healthier and more
                comfortable. By sharing these products with others,
                you can earn rewards and incentives through Springway’s
                business model.`
        },
        {
            id: 2,
            image: image1,
            title: "Springway Vegetable Garden",
            desc: `Growing fresh vegetables at home ensures a healthy diet and reduces
                    dependence on store-bought produce. Springway promotes organic
                    vegetable gardening, encouraging people to cultivate their own food
                    in their backyard or terrace. This initiative not only provides
                    fresh and chemical-free vegetables but also creates an income-generating opportunity.
                    Springway supports individuals by providing high-quality seeds,
                    guidance, and market opportunities to help them succeed in vegetable cultivation.`,
        },
        {
            id: 3,
            image: image4,
            title: "Springway Garden",
            desc: `The garden is an integral part of a house. It enhances the 
            aesthetic appeal and spiritual well-being of the home. A well-maintained garden contributes 
            to a pleasant and healthy living environment. The presence of plants brings freshness and positive 
            energy into our lives.Creating a garden in residential and commercial spaces is what 
            Springway Garden aims to promote.The company encourages planting Portulaca, a flowering plant, 
            which can be cultivated and nurtured to generate income with the support of Springway.`
        },
        {
            id: 4,
            image: image5,
            title: "Springway",
            desc: `In today’s digital age, advertising plays a crucial role in business growth.
                    Springway Ads provides an effective digital marketing platform to promote products and
                    services to a wider audience. This platform enables business owners and entrepreneurs to
                    market their offerings efficiently, increasing visibility and customer engagement.
                    With customized advertising solutions,
                    Springway helps businesses reach the right audience and maximize
                    their marketing potential.`
        },
        {
            id: 5,
            image: image2,
            title: "Virtual Mall",
            desc: `Springway introduces an innovative virtual shopping experience
                    through the Springway Virtual Mall. This platform allows customers
                    to explore and purchase products online with ease.
                    It creates a new-age digital shopping environment where users can
                    browse a variety of categories, compare prices, and make secure
                    transactions. Springway’s virtual mall system is designed to 
                    enhance the online shopping experience for its members, making it more convenient and interactive.`
        },
        {
            id: 6,
            image: image6,
            title: "Springway Ads",
            desc: `In today’s digital age, advertising plays a crucial role in business growth.
                    Springway Ads provides an effective digital marketing platform to promote products and
                    services to a wider audience. This platform enables business owners and entrepreneurs to
                    market their offerings efficiently, increasing visibility and customer engagement.
                    With customized advertising solutions,
                    Springway helps businesses reach the right audience and maximize
                    their marketing potential.`
        }
    ];

    const specialEvents = [
        {
            id: 1,
            image: "/images/vishu.jpeg",
            alt: "special events",
        }
    ]

    const handleLogin = () => {
        navigate('/login');
    }

    const handleRegister = () => {
        navigate('/register');
    }

    const handleVirtualMall = () => {
        navigate('/my_ads');
    }

    const handleVirtualMallLogin = () => {
        navigate('/virtual_mall_login');
    }

    if (dashboardPath) {
        return null;
    }

    return (

        <>


            <div style={{ background: "linear-gradient(to bottom, rgb(3, 3, 85), black)" }}>
                <ToastContainer />
                <Navbar
                    expand="lg"
                    // bg="dark"
                    // variant="dark"
                    expanded={expanded}
                    onToggle={() => setExpanded(!expanded)}
                    className="py-3 navbar sticky-top"
                >
                    <Container>
                        <div className="d-flex align-items-center w-100">
                            {/* Logo */}
                            <Navbar.Brand href="#" className="me-2"> {/* Reduced margin */}
                                <img
                                    src="./images/main_logo.png"
                                    alt="Logo"
                                    height="60"
                                />
                            </Navbar.Brand>

                            {/* **Sticky Quote (Beside Logo) ** */}
                            <div className="text-left ms-2" style={{ flex: 1, minWidth: "150px" }}>
                                <p style={{ color: "#edf106e8" }} className="mb-0 fst-italic small">
                                    “ Share with others earn happy much more ”</p>
                            </div>

                            {/* Toggle Button (Pushed to Far Right) */}
                            <Navbar.Toggle
                                aria-controls="basic-navbar-nav"
                                className="ms-auto"
                            />
                        </div>
                        {/* <Navbar.Toggle aria-controls="basic-navbar-nav"
                        // className="navbar-toggler-white" 
                        /> */}

                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav
                                className="ms-auto d-flex flex-column flex-lg-row align-items-center align-items-lg-center gap-4 nav-content"
                                onClick={() => setExpanded(false)}
                            >
                                <Nav.Link href="#AboutUs" className="text-white">About</Nav.Link>
                                <Nav.Link href="#ContactUs" className="text-white">Contact</Nav.Link>

                                <Button
                                    variant="info"
                                    style={{
                                        backgroundColor: "#229eb4",
                                        border: "none",
                                        minWidth: "120px",
                                        height: "40px",
                                        padding: "0 16px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "white"
                                    }}
                                    onClick={handleLogin}
                                >
                                    Login
                                </Button>

                                {/* <Button
                                    variant="info"
                                    style={{
                                        backgroundColor: "#229eb4",
                                        border: "none",
                                        minWidth: "120px",
                                        height: "40px",
                                        padding: "0 16px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "white"
                                    }}
                                    onClick={handleRegister}
                                >
                                    Register
                                </Button> */}
                                <Button
                                    variant="info"
                                    style={{
                                        backgroundColor: "#229eb4",
                                        border: "none",
                                        minWidth: "120px",
                                        height: "40px",
                                        padding: "0 16px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "white"
                                    }}
                                    onClick={handleVirtualMall}>Virtual Mall</Button>
                                {/* <Button
                                    variant="info"
                                    style={{
                                        backgroundColor: "#229eb4",
                                        border: "none",
                                        minWidth: "200px",
                                        height: "40px",
                                        padding: "0 16px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "white"
                                    }}
                                    onClick={handleVirtualMallLogin}>Virtual Mall Login</Button> */}
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>


                <section className="w-100 d-flex align-items-center adsection1 px-4 py-5">
                    <div className="container-fluid">
                        <div className="row justify-content-center align-items-center gy-4">
                            {/* Left Image */}
                            <InstructionCarousel />
                            {/* Right Carousel */}
                            {/* <div
                                id="carouselExample"
                                className="carousel slide w-100 position-relative"
                                data-bs-ride="carousel"
                                style={{ maxWidth: '500px' }}
                            >
                                <div className="carousel-inner">
                                    {AdImages.map((ad, index) => (
                                        <div
                                            key={ad.ad_id}
                                            className={`carousel-item ${index === 0 ? 'active' : ''}`}
                                        >
                                            <img
                                                src={'https://api.springwayhub.com/' + ad.ad_image}
                                                className="d-block w-100"
                                                style={{ height: '400px', objectFit: 'fill' }}
                                                alt="advertisements"
                                            />
                                        </div>
                                    ))}
                                </div>

                                <button
                                    className="carousel-control-prev position-absolute top-50 translate-middle-y"
                                    type="button"
                                    data-bs-target="#carouselExample"
                                    data-bs-slide="prev"
                                    style={{ left: '-20px' }}
                                >
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>

                                <button
                                    className="carousel-control-next position-absolute top-50 translate-middle-y"
                                    type="button"
                                    data-bs-target="#carouselExample"
                                    data-bs-slide="next"
                                    style={{ right: '-20px' }}
                                >
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div> */}

                        </div>
                    </div>
                </section>

                <div id="servicesCarousel" className="carousel slide maindiv text-center" data-bs-ride="carousel">
                    <h1>OUR PRODUCTS</h1>
                    <div className="carousel-inner">
                        {products.map((product, index) => (
                            <div
                                key={product.id}
                                className={`carousel-item ${index === 0 ? 'active' : ''}`}
                            >
                                <div className="d-flex flex-column align-items-center justify-content-center h-100 carousel-content">
                                    <div className="real-estate-card text-center p-4" style={{ maxWidth: '800px' }}>
                                        <img
                                            src={product.image}
                                            alt={product.title}
                                            className="d-block mx-auto mb-4"
                                            style={{
                                                height: '400px',
                                                width: '400px',
                                                objectFit: 'contain'
                                            }}
                                        />
                                        <div className="real-estate-details">
                                            <h3 className="real-estate-title mb-3">{product.title}</h3>
                                            <p className="real-estate-desc mx-auto" style={{ maxWidth: '600px' }}>
                                                {product.desc}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Carousel controls */}
                    <button
                        className="carousel-control-prev"
                        type="button"
                        data-bs-target="#servicesCarousel"
                        data-bs-slide="prev"
                    >
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>

                    <button
                        className="carousel-control-next"
                        type="button"
                        data-bs-target="#servicesCarousel"
                        data-bs-slide="next"
                    >
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>

                <section className="w-100 d-flex align-items-center adsection1 px-4 py-5">
                    <div className="container-fluid">
                        <div className="row justify-content-center align-items-center gy-4">
                            <div className="col-12 col-md-6 text-center rounded p-4" style={{ background: "linear-gradient(to bottom, rgb(3, 3, 85), #8fecec)" }}>
                                <h1>MISSION & VISION</h1>
                                <p>Springway's vision is to provide an opportunity for any ordinary individual
                                    who wishes to earn additional income alongside their current earnings.
                                    By offering a business opportunity at minimal cost,
                                    Springway aims to empower individuals to achieve a stable monthly income.
                                    To realize this vision, Springway initiates projects that support this goal
                                    and ensures that individuals who are part of the Springway business receive the
                                    necessary assistance and support to succeed.</p>
                            </div>

                            <div className="col-12 col-md-6 d-flex justify-content-center">
                                {console.log(AdImages[AdImages.length - 3]?.ad_image, 'AdImages[AdImages.length - 1]?.ad_image')}
                                <img
                                    src={AdImages[AdImages.length - 3]?.ad_image ? 'https://api.springwayhub.com/' + AdImages[AdImages.length - 3]?.ad_image : AdImages[AdImages.length - 3]?.ad_image}
                                    alt="advertisements"
                                    className="rounded shadow w-100"
                                    style={{ maxWidth: '500px', height: 'auto', objectFit: 'fill' }}
                                />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="w-100 d-flex align-items-center adsection1 px-4 py-5">
                    <div id="AboutUs" className="container-fluid">
                        <div className="row justify-content-center align-items-center gy-4">
                            <div
                                id="carouselExample1"
                                className="carousel slide w-100 position-relative"
                                data-bs-ride="carousel"
                                style={{ maxWidth: '500px' }}
                            >
                                <div className="carousel-inner">
                                    {AdImages.map((ad, index) => (
                                        <div
                                            key={ad.ad_id}
                                            className={`carousel-item ${index === 0 ? 'active' : ''}`}
                                        >
                                            <img
                                                src={'https://api.springwayhub.com/' + ad.ad_image}
                                                className="d-block w-100"
                                                style={{ height: '400px', objectFit: 'fill' }}
                                                alt="advertisements"
                                            />
                                        </div>
                                    ))}
                                </div>

                                {/* External Previous Button */}
                                <button
                                    className="carousel-control-prev position-absolute top-50 translate-middle-y"
                                    type="button"
                                    data-bs-target="#carouselExample1"
                                    data-bs-slide="prev"
                                    style={{ left: '-20px' }}
                                >
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>

                                {/* External Next Button */}
                                <button
                                    className="carousel-control-next position-absolute top-50 translate-middle-y"
                                    type="button"
                                    data-bs-target="#carouselExample1"
                                    data-bs-slide="next"
                                    style={{ right: '-20px' }}
                                >
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>

                            <div
                                className="col-12 col-md-6 text-center rounded p-4"
                                style={{
                                    background: "linear-gradient(to bottom, rgb(3, 3, 85), #8fecec)",
                                    borderRadius: "20px",
                                    padding: "2rem",
                                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    //border: "2px solid #00ffff"
                                }}
                            >
                                <h1 className="text-white mb-4">ABOUT US</h1>
                                <p className="text-white">
                                    "A to Z" was established in 2015 in Kollam district, Kerala, as a traditional business manufacturing and directly selling cleaning products to consumers. This approach continued until 2024. However, due to the highly competitive market, we decided to shift towards online marketing, which offers greater sales potential and more direct engagement with customers. From 2024 onwards, we began marketing our cleaning products online and successfully launched our digital sales operations.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>


                <section id="ContactUs" className="w-100 d-flex align-items-center adsection1 px-4 py-5">
                    <div className="container-fluid">
                        <div className="row gy-4">
                            <div className="col-12 col-md-4">
                                <div className="section-content text-center">
                                    <Navbar.Brand href="#">
                                        <img
                                            src="./images/main_logo.png"
                                            alt="Logo"
                                            className="kp-logo-image"
                                            height="70"
                                        />
                                        <span className="navbar-quote d-none d-md-block" style={{ color: "#00ffff" }}>
                                            SPRINGWAY
                                        </span>
                                    </Navbar.Brand>
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <div className="section-content text-center">
                                    <h3 style={{ color: "#00ffff" }}>SPRINGWAY HOME CARE</h3>
                                    <p>PAKALKURI PALLICKAL (po)</p>
                                    <p>TVM PIN (695604)</p>
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <div className="section-content text-center">
                                    <h3 style={{ color: "#00ffff" }}>SPRINGWAY VEGETABLE GARDEN</h3>
                                    <p>PAKALKURI PALLICKAL (po) TVM</p>
                                    <p>PIN (695604)</p>
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <div className="section-content text-center">
                                    <h3 style={{ color: "#00ffff" }}>SPRINGWAY GARDEN</h3>
                                    <p>PAKALKURI PALLICKAL (po) TVM</p>
                                    <p>PIN (695604)</p>
                                    <p>SUB UNIT, SPW</p>
                                    <p>VELLANAD TVM PIN (695542)</p>
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <div className="section-content text-center">
                                    <h3 style={{ color: "#00ffff" }}>SPRINGWAY</h3>
                                    <p>VIJAYA TOWER</p>
                                    <p>MEVARAM (NH 66)</p>
                                    <p>KOLLAM PIN 691020</p>
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <div className="section-content text-center">
                                    <h3 style={{ color: "#00ffff" }}>Call Us</h3>
                                    <p>9037 966 301</p>
                                    <p>9037 966 302</p>
                                    <p>9037 966 303</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >

                <ScrollToTop
                    className="scroll"
                    smooth
                    component={
                        <div className="progress-circle">
                            <svg width="50" height="50" viewBox="0 0 100 100">
                                <circle
                                    cx="50"
                                    cy="50"
                                    r="40"
                                    stroke="lightgray"
                                    strokeWidth="8"
                                    fill="none"
                                />
                                <circle
                                    cx="50"
                                    cy="50"
                                    r="40"
                                    stroke="#229eb4"
                                    strokeWidth="8"
                                    fill="none"
                                    strokeDasharray="251.2"
                                    strokeDashoffset={251.2 - (scrollProgress / 100) * 251.2}
                                    strokeLinecap="round"
                                />
                            </svg>
                        </div>
                    }
                    style={{ background: "transparent", boxShadow: "none" }}
                />
            </div>
        </>
    );
};

export default LandingPage;

